import { foldazApi } from 'api'
import {
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_ERROR,
} from './types'

export const state = {
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [UPDATE_USER_ROLE_REQUEST] (state) {
    state.request.isLoading = true
  },
  [UPDATE_USER_ROLE_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [UPDATE_USER_ROLE_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  }
}

export const actions = {
  updateUserRole ({ commit }, { user, role }) {
    commit(UPDATE_USER_ROLE_REQUEST)

    return new Promise(function (resolve, reject) {
      foldazApi.put('/users/' + user.id, {
        id: user.id,
        role: role
      })
        .then(response => {
          commit(UPDATE_USER_ROLE_SUCCESS)
          resolve(response.data)
        })
        .catch(error => {
          commit(UPDATE_USER_ROLE_ERROR, error)
          reject(error)
        })
    })
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users/updateUserRole.js